import React, { Fragment } from "react";

import { Link } from "react-router-dom";
import { Table, Header } from "semantic-ui-react";
import { get, isEmpty } from 'lodash'

const ReturnType = ({ objectType, type }) => {
  const fields = get(type, "fields", [])
  return (
    <Fragment>
      <Header as="h1" color="grey">
        Return Type
        <Header.Subheader>
          The expected object returned by the {objectType}
        </Header.Subheader>
      </Header>
      <Header as="h3" color="blue">
        {type.name}
        <Header.Subheader>
          {type.description || "A graphql object"}
        </Header.Subheader>
      </Header>
      {(type.kind === "OBJECT" || type.kind === "INPUT_OBJECT") && !isEmpty(type.fields) && (
        <Table compact celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Type</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              fields.map((field, index) => {
                let objArray
                let obj = field.type.name
                if (!obj) {
                  obj = field.type.ofType.name
                }

                // return type is an array
                if (field.type.ofType && field.type.kind === "LIST") {
                  objArray = `[${obj}]`
                }
                return (
                  !field.name.includes("password") && ( // temporary solution to hide passwords in documentation
                    <Table.Row key={index}>
                      <Table.Cell>{field.name}</Table.Cell>
                      <Table.Cell>
                        <Link
                          to={`/reference/types/${obj}`}
                          onClick={() => window.scrollTo(0, 0)}
                        >
                          {objArray || obj}
                        </Link>
                      </Table.Cell>
                      <Table.Cell
                      // selectable={selectableValue}
                      // onClick={this.handleModalOpen.bind(
                      //   this,
                      //   field.description,
                      //   index
                      // )}
                      >
                        {field.description || (<strong>The description is not available.</strong>)}
                      </Table.Cell>
                    </Table.Row>
                  )
                )
              })
            }
          </Table.Body>
        </Table>
      )}
    </Fragment>
  )
}

export default ReturnType
